import React, { useState } from "react";
import ReactJson from "react-json-view";
import { ChevronRightSvg } from "../../assets/svgs";
import { DetailContainer, DetailText, ExpandIcon, JsonWrapStyle, ViewDetailsTableWrapper, } from "./view-details-table.style";

const ViewDetailsTable = ({ data }) => {
    const initialStates = {
        stringLength: 150,
        expand: null,
    };

    const [states, setStates] = useState(initialStates);

    const isReactElement = (value) => React.isValidElement(value);

    // Check if value is a plain object
    const isObject = (value) => value && typeof value === "object" && !isReactElement(value);

    // Check if string is JSON
    const isJsonString = (str) => {
        if (typeof str !== "string") return false;
        try {
            const parsed = JSON.parse(str);
            return typeof parsed === "object" && parsed !== null;
        } catch {
            return false;
        }
    };

    // Recursively parse nested JSON strings
    const parseDeepJson = (value) => {
        if (isReactElement(value)) {
            return value;
        }

        if (isJsonString(value)) {
            const parsed = JSON.parse(value);
            Object.keys(parsed).forEach((key) => {
                parsed[key] = parseDeepJson(parsed[key]);
            });
            return parsed;
        } else if (isObject(value)) {
            const newObj = Array.isArray(value) ? [] : {};
            Object.keys(value).forEach((key) => {
                newObj[key] = parseDeepJson(value[key]);
            });
            return newObj;
        }
        return value;
    };

    return (
        <ViewDetailsTableWrapper>
            <JsonWrapStyle />

            {data &&
                data.length > 0 &&
                data.map(({ label, value }) => {
                    const parsedValue = parseDeepJson(value);

                    const isJsonLike = isObject(parsedValue);

                    return (
                        <DetailContainer key={label}>
                            <DetailText>
                                <strong>{label}:</strong>{" "}
                                {value !== null && value !== undefined ? (
                                    isReactElement(value) ? (
                                        value
                                    ) : isJsonLike ? (
                                        // Use ReactJson for objects
                                        <ReactJson
                                            src={parsedValue}
                                            name={false}
                                            collapsed={states.expand === label ? false : true}
                                            displayDataTypes={false}
                                            enableClipboard={false}
                                            indentWidth={4}
                                            style={{
                                                backgroundColor: "transparent",
                                                fontSize: "13px",
                                                padding: "10px",
                                            }}
                                        />
                                    ) : (
                                        <>
                                            {states.expand === label
                                                ? String(value)
                                                : String(value).substring(0, states.stringLength)}
                                            {String(value).length > states.stringLength &&
                                                !states.expand &&
                                                "..."}
                                        </>
                                    )
                                ) : (
                                    "null"
                                )}
                            </DetailText>

                            {value !== null && value !== undefined &&
                                typeof value === "string" &&
                                !isJsonString(value) &&
                                value.length > states.stringLength && (
                                    <ExpandIcon
                                        onClick={() =>
                                            setStates((old) => ({
                                                ...old,
                                                expand: states.expand === label ? null : label,
                                            }))
                                        }
                                    >
                                        <ChevronRightSvg
                                            style={{
                                                rotate: states.expand === label ? "270deg" : "90deg",
                                            }}
                                        />
                                    </ExpandIcon>
                                )}
                        </DetailContainer>
                    );
                })}
        </ViewDetailsTableWrapper>
    );
};

export default ViewDetailsTable;
